//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer    } from 'components/Spacer';
import { ColumnMap } from './components/ColumnMap/ColumnMap';

// === UTILS ===
//#endregion

//-----------------------------------------------------------------
export function ColumnMapList( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { data, columns1, columns2, onMapChange, is_predicate } = props;

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      width:'100%',
    },
    select_field: {
      width: '40rem',
    },
    select_column: {
      width: '30rem',
    },
    text_table2: {
      width: '40rem',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_expand: {
      width  : '3rem',
      height : '3rem',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white',
    },
    button_remove: {
      width  : '3rem',
      height : '3rem',
    },
  }

  const TABLE_2_COLUMN = {
    sx        : _styles.select_column,
    key       : 'table-2-column',
    size      : 'small',
  };

  const BUTTON_ADD = {
    sx: _styles.button_add,
    key : 'add',
    children: <Add />,
    onClick: onClick_Add,
  };

  const BUTTON_DELETE = {
    sx: _styles.button_remove,
    key : 'remove',
    // variant: 'contained',
    // onClick: () => expression.removeExpression(id),
    children: <Delete />,
  };
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {

  }, [] );

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Add() {
    //-----------------------------------------------------------------
    const map = data ? { ...data } : { items: {}, order: [] };
    const next_id = map.order.length > 0 ? (Math.max( ...map.order ) + 1) : 0;
    map.items[next_id] = { table1: '', table2: '' };
    map.order.push( next_id );
    
    onMapChange( map );
  }

  //-----------------------------------------------------------------
  function handleColumnChange( id, type, field1, field2 ) {
    //-----------------------------------------------------------------
    const map = data ? { ...data } : { items: {}, order: [] };
    
    if( type   ) map.items[id].type   =   type;
    if( field1 ) map.items[id].table1 = field1;
    if( field2 ) map.items[id].table2 = field2;

    onMapChange( map );
  }

  //-----------------------------------------------------------------
  function handleColumnRemove( id ) {
    //-----------------------------------------------------------------
    const map = data ? { ...data } : { items: {}, order: [] };
    delete map.items[id]
    const index = map.order.indexOf( id );
    map.order.splice( index, 1 );
    
    onMapChange( map );
  }

  //-----------------------------------------------------------------
  function handleColumnReorder( id_from, id_to, is_above ) {
    //-----------------------------------------------------------------
    const map = data ? { ...data } : { items: {}, order: [] };

    const index_from = map.order.indexOf( id_from );
    const index_to   = map.order.indexOf( id_to  );
    const from_above = index_from < index_to; 
    const to_above_from_above =  is_above &&  from_above;
    const to_above_from_below =  is_above && !from_above;
    const to_below_from_above = !is_above &&  from_above;
    const to_below_from_below = !is_above && !from_above;

    const direction = to_above_from_above ? 0 : to_above_from_below ? 0 : to_below_from_above ? 0 : to_below_from_below ? 1 : 0;
    const index_delete = index_from;

    map.order.splice( index_delete, 1          );
    const index_insert = map.order.indexOf( id_to ) + direction;
    map.order.splice( index_insert, 0, id_from );

    onMapChange( map );
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={_styles.container}>
        <div style={{ margin:'0.5rem', width:'100%', alignItems:'center', display: 'flex'}}>
          <Spacer />
            Column Map
          <Spacer width='4rem' />
          <Tooltip title='Add column map' placement='top'>
            <IconButton { ...BUTTON_ADD  } />
          </Tooltip>
        </div>
        {
          data?.order?.map( (id, index) => {
            const _map = data?.items[id];
            return (
              <ColumnMap
                key      = {id}
                id       = {id}
                index    = {index}
                type     = {_map.type  }
                field1   = {_map.table1}
                field2   = {_map.table2}
                columns1 = {columns1}
                is_predicate = {is_predicate}
                onColumnChange  = {handleColumnChange}
                onColumnRemove  = {handleColumnRemove}
                onColumnReorder = {handleColumnReorder}
              />
            )
          })
        }
      </div>
    );
  }



  //#endregion

  return display();
}